import {Component, OnInit} from '@angular/core';
import {BehaviorSubject, combineLatest} from "rxjs";
import NoteModel from "../../../../model/note.model";
import ContextBarService from "../context-bar.service";
import NoteService from "../../../../api/note/note.service";
import {debounceTime, first} from "rxjs/operators";
import {MatSnackBar} from "@angular/material/snack-bar";
import UserModel from "../../../../model/user.model";

@Component({
  selector: 'context-bar-notes',
  templateUrl: './notes.component.html',
  styleUrls: ['./notes.component.scss']
})
export class NotesComponent implements OnInit {
  private notesSubject = new BehaviorSubject<NoteModel[]>([]);
  public notes$ = this.notesSubject.asObservable();

  private pageSubject = new BehaviorSubject<number>(1);
  public page$ = this.pageSubject.asObservable();

  private querySubject = new BehaviorSubject<string>(null);
  public query$ = this.querySubject.asObservable();

  private loadingSubject = new BehaviorSubject<boolean>(false);
  public loading$ = this.loadingSubject.asObservable();

  public noteCount = 0;

  public newNote: NoteModel;

  public constructor(private contextBarService: ContextBarService, private noteService: NoteService, private snackBar: MatSnackBar) {

  }

  ngOnInit() {
    this.newNote = {
      text: ''
    };

    combineLatest([ this.contextBarService.artist$, this.contextBarService.cooperation$, this.contextBarService.customer$, this.query$]).subscribe(_ => {
      this.pageSubject.next(1);

    });

    combineLatest([
      this.contextBarService.artist$, this.contextBarService.cooperation$, this.contextBarService.customer$, this.page$, this.query$
    ]).pipe(debounceTime(500)).subscribe(([artist, cooperation, customer, page, query]) => {
      let additional = {};

      this.newNote.markedUser = artist?.user;
      this.newNote.cooperation = cooperation;
      this.newNote.customer = customer;

      if(artist) {
        additional['artist'] = artist.id;
      }
      if(cooperation) {
        additional['cooperation'] = cooperation.id;
      }
      if(customer) {
        additional['customer'] = customer.id;
      }

      this.loadingSubject.next(true);
      this.noteService.list(query, page, 25, 'created', 'DESC', additional).subscribe(result => {
        if(page == 1) {
          this.notesSubject.next(result.results);
        } else {
          let items = this.notesSubject.getValue();
          items = items.concat(result.results);
          this.notesSubject.next(items);
        }
        this.loadingSubject.next(false);
        this.noteCount = result.total;
      })
    });
  }

  addNote(note: NoteModel) {
    if (note.text === '') {
      return;
    }

    if (this.contextBarService.getArtistSnapshot() != null &&
        this.contextBarService.getArtistSnapshot().user != null) {
      note.markedUser = {
        id: this.contextBarService.getArtistSnapshot().user.id
      } as UserModel;
    }


    this.noteService.create(note).pipe(first()).subscribe(result => {
      const notes = this.notesSubject.getValue();
      notes.unshift(result);
      this.notesSubject.next(notes);
      this.snackBar.open('Notiz hinzugefügt');
    });
  }

  onScroll() {
    if(this.notesSubject.getValue().length < this.noteCount) {
      this.pageSubject.next(this.pageSubject.getValue() + 1);
    }
  }

  queryChanged(query) {
    this.querySubject.next(query);
  }

  noteDeleted(note: NoteModel) {
    const items = this.notesSubject.getValue();
    const index = items.indexOf(note);
    if(index >= 0) {
      items.splice(index, 1);
      this.notesSubject.next(items);
    }
  }

}
